"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Resources = /** @class */ (function () {
    function Resources() {
    }
    //Themes
    Resources.body = "body";
    Resources.theme = "theme";
    Resources.default = "default";
    Resources.light = "light";
    Resources.dark = "dark";
    Resources.contrast = "contrast";
    //KeyCodes
    Resources.keyCodeEnter = 13;
    Resources.keyCodeSpace = 32;
    return Resources;
}());
exports.default = Resources;
//# sourceMappingURL=resources.js.map